"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This function validates if a string is a valid vimeo url
 * @memberof StringUtils
 * @function isVimeoURL
 * @param  {String} url to validate
 * @return {Boolean} true if valid vimeo url
 */
var isVimeoURL = function isVimeoURL(url) {
  return (/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/g.test(url)
  );
};

exports.default = isVimeoURL;